import React from 'react';
import App2 from './immo-pro';

function App() {
  return <App2 />;
}

export default App;
